/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { LinearProgress, Subheader } from 'material-ui';
import globalEvents from '../../events';
import { SMALL } from '../../utils/withWidth';
import actions from '../../state/actions';
import RequestCard from './RequestCard';
import RequestsTopBar from './RequestsTopBar';
import Screen from '../../components/Screen';
import { PageLoader, RandomEmptyPage, EmptyPage } from '../../components/PageWrapper';
import EndlessScrollView from '../../components/EndlessScrollView';
import { RequestCardType } from './types';
import { retrieveServiceRequestItems, loadNextPage } from './RequestState';
import { localize, t } from '../../i18n';

import './Requests.css';

const RequestList = localize(((props) => {
  const {
    requests,
    type,
    width,
  } = props;

  const mobileView = width <= SMALL;
  const gridClassNames = [
    'uk-grid',
    'uk-grid-medium',
    'uk-grid-width-small-1-1',
    'uk-grid-width-medium-1-2',
    'uk-grid-width-large-1-2',
    mobileView ? 'list_view' : 'grid_view',
  ].join(' ');

  const cardsRef = {};

  const closeOtherCards = (request) => {
    _.without(_.keys(cardsRef), request._id)
      .forEach((key) => {
        const card = cardsRef[key] && cardsRef[key].current;
        return card.close();
      });
  };

  const subheaderClasses = [
    'capitalize',
    mobileView ? '' : 'uk-margin-small-bottom',
  ].join(' ');

  const renderCard = (options) => {
    const { request, channel, serviceConfig } = options;
    const ref = createRef();
    cardsRef[request._id] = ref;

    return (
      <RequestCard
        key={request._id}
        groupType={type}
        ref={ref}
        request={request}
        channel={channel}
        serviceConfig={serviceConfig}
        onOpen={closeOtherCards}
      />
    );
  };

  return (
    <div className={`${mobileView ? '' : 'uk-margin-small-top'}`}>
      <Subheader className={subheaderClasses}>{props.t(type)}</Subheader>
      <div className={gridClassNames}>{requests.map(renderCard)}</div>
    </div>
  );
}));

RequestList.propTypes = {
  requests: PropTypes.arrayOf(RequestCardType),
  type: PropTypes.string.isRequired,
  width: PropTypes.number,
  t: PropTypes.func,
};

const ScreenContent = ({ children }) => (
  <div className="loading-wrapper">
    <div className="loading-placeholder">
      {children}
    </div>
  </div>
);

ScreenContent.propTypes = {
  children: PropTypes.node,
};

class Requests extends React.Component {
  componentWillMount() {
    this.props.dispatch(actions.setHeaderTitle(this.props.t('Service requests')));

    this.retrieveRequests = (foreground = false) => {
      const {
        requests: {
          pageNumber,
        },
      } = this.props;

      if (pageNumber === 0) {
        this.props.dispatch(retrieveServiceRequestItems(foreground));
      }
    };

    this.intervalTimer = setInterval(this.retrieveRequests, 60 * 1000);
    globalEvents.on('notifications.content_available', this.retrieveRequests);

    this.retrieveRequests();
  }

  componentWillUnmount() {
    clearInterval(this.intervalTimer);
    globalEvents.off('notifications.content_available', this.retrieveRequests);
  }

  render() {
    const {
      requests,
      width,

    } = this.props;

    const groups = [t('current'), t('future'), t('done')];
    const hasNext = !!requests.nextPageUrl;
    const isEmpty = groups.reduce((c, group) => c + requests[group].length, 0) === 0;

    const renderRandomEmptyScreen = () => (
      <RandomEmptyPage>
        <EmptyPage icon="done_all" offset={88}>
          <span>{this.props.t('Everything is done')}.</span><br />
          <span>{this.props.t('Great job')}!</span>
        </EmptyPage>

        <EmptyPage icon="local_cafe" offset={88}>
          <span>{this.props.t('Grab some coffee')}.</span><br />
          <span> {this.props.t('We\'ll let you know')}.</span>
        </EmptyPage>

        <EmptyPage icon="spa" offset={88}>
          <span>{this.props.t('No requests so far')}.</span><br />
          <span>{this.props.t('Time for a break')}.</span>
        </EmptyPage>
      </RandomEmptyPage>
    );

    const renderList = () =>
      (isEmpty ?
          (renderRandomEmptyScreen()) : (
            <EndlessScrollView
              onNextPage={() => {
                if (hasNext) {
                  this.props.dispatch(loadNextPage(requests.nextPageUrl));
                }
              }}
              inLoading={requests.inNextPageLoading}
              offset={670}
            >
              {groups.map(group => (requests[group].length ?
                <RequestList requests={requests[group]} type={group} key={group} width={width} /> :
                null))
              }
            </EndlessScrollView>
          )
      );

    return (
      <Screen title={this.props.t('Requests')} helpUrl="#sr">
        <RequestsTopBar />
        <div className="Requests">
          { requests.backgroundLoading ?
            <LinearProgress mode="indeterminate" className="background-progress" style={{ position: 'fixed' }} /> : null }


          { requests.initialLoading ? (
            <PageLoader title={this.props.t('Getting requests')} offset={88} />
          ) : renderList()}
        </div>
      </Screen>
    );
  }
}

Requests.propTypes = {
  requests: PropTypes.shape({
    future: PropTypes.arrayOf(RequestCardType),
    current: PropTypes.arrayOf(RequestCardType),
    done: PropTypes.arrayOf(RequestCardType),
    initialLoading: PropTypes.bool,
    backgroundLoading: PropTypes.bool,
    inNextPageLoading: PropTypes.bool,
    nexPageUrl: PropTypes.string,
  }),
  width: PropTypes.number,
  dispatch: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ views: { requests }, layout: { size: width } }) => ({ requests, width });

export default localize(connect(mapStateToProps)(Requests));



// WEBPACK FOOTER //
// ./src/views/requests/Requests.js